var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10209",
    "data-name": "Group 10209",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.605,
    height: 37.077,
    viewBox: "0 0 34.605 37.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2234",
    "data-name": "Rectangle 2234",
    width: 34.605,
    height: 37.077,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10208",
    "data-name": "Group 10208",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27573",
    "data-name": "Path 27573",
    d: "M30.9,8.651H24.718V3.708A3.709,3.709,0,0,0,21.01,0H3.708A3.709,3.709,0,0,0,0,3.708V33.369a3.709,3.709,0,0,0,3.708,3.708h17.3a3.709,3.709,0,0,0,3.708-3.708V32.133a1.236,1.236,0,1,0-2.472,0v1.236A1.236,1.236,0,0,1,21.01,34.6H3.708a1.236,1.236,0,0,1-1.236-1.236V3.708A1.236,1.236,0,0,1,3.708,2.472h17.3a1.236,1.236,0,0,1,1.236,1.236V8.651H8.651a3.709,3.709,0,0,0-3.708,3.708V24.718a3.709,3.709,0,0,0,3.708,3.708H30.9A3.709,3.709,0,0,0,34.6,24.718V12.359A3.709,3.709,0,0,0,30.9,8.651m1.236,16.066A1.236,1.236,0,0,1,30.9,25.954H8.651a1.236,1.236,0,0,1-1.236-1.236V19.774H32.133Zm0-7.415H7.415V16.066H32.133Zm0-3.708H7.415V12.359a1.236,1.236,0,0,1,1.236-1.236H30.9a1.236,1.236,0,0,1,1.236,1.236Z",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27574",
    "data-name": "Path 27574",
    d: "M13.151,4.722a1.236,1.236,0,1,0,0-2.472H5.736a1.236,1.236,0,1,0,0,2.472ZM8.208,29.439a1.236,1.236,0,1,0,0,2.472h2.472a1.236,1.236,0,1,0,0-2.472Z",
    transform: "translate(2.915 1.458)",
    fill: "#ffe800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon17);
export default __webpack_public_path__ + "static/media/social_icon17.6c104ce3b6573781405fa3020af7b687.svg";
export { ForwardRef as ReactComponent };